module.exports = __webpack_public_path__ + "static/feature-rounding-205ee8a7c7013e2c60ffa661cd251780.png";